import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ChangeTradingAccountStatusFormErrorStatesEnum {
    UpdateTradingAccountStatusFailed = ErrorStateScheduleEnum.ChangeTradingAccountStatusFormStatesStartIndex,
    NotActiveAccountOwner,
    UpdateTradingAccountStatusToClosedRestricted
}
